const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
      api: "https://hanoiip-api.cgis.asia/",
      domainUserSide: "http://localhost:3000",
      domainAdminSide: "http://localhost:3000",
      domainName: "hanoiip.cgis.asia",
      doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
      doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/wms",
  },
  production: {
      api: "https://hanoiip-api.cgis.asia/",
      domainUserSide: "https://hanoiip.cgis.asia",
      domainAdminSide: "https://admin.hanoiip.cgis.asia",
      domainName: "hanoiip.cgis.asia",
      doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
      doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/wms",
  },
};

module.exports = apiEnvironment[env];
